import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../core/dto/page.size';
import { Router } from '@angular/router';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../core/dto/pagination';
import * as _ from 'lodash';
import { SETTINGS } from '../../core/config/common.settings';
import { CurrencyService } from '../../core/services/currency.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-currency-configuration',
  templateUrl: './currency-configuration.component.html',
  styleUrls: ['./currency-configuration.component.scss'],
})
export class CurrencyConfigurationComponent implements OnInit {
  breadcrumbs: any[] = [];
  searchText: any;
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  agentsData: any[] = [];

  skeletonTableColumns: any[] = [
    'Currency Code',
    'Currency Name',
    'LKR Rate',
    'Created Date',
    'Actions',
  ];
  loading = false;

  isVisibleCurrencyAddEdit = false;
  selectedCurrency: any;
  currencyCode = '';
  currencyName = '';
  lkrRate = 0;
  isLoading = false;
  modalType = '';

  constructor(
    private router: Router,
    private currencyService: CurrencyService,
    private messages: NzMessageService,
  ) {}

  ngOnInit() {
    this.setBreadcrumbs();
    this.getPagedCurrencies();
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedCurrencies();
  }

  getPagedCurrencies(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchValue: this.searchText,
      },
    });
    this.currencyService.getPagedCurrencies(payload).subscribe(
      (res: any) => {
        this.loading = false;
        this.agentsData = res[0].data;
        this.pageSize.length = res[0].metadata[0]?.total;
      },
      (error: any) => {
        if (error.status === 403 && error?.error?.message) {
          this.messages.create('error', error?.error?.message);
        }
      },
    );
  }

  search(): void {
    this.getPagedCurrencies();
  }

  resetSearch(): void {
    this.searchText = null;
    this.getPagedCurrencies();
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: `Currency Configuration`,
        route: '/admin/currency-config',
      },
    ];
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedCurrencies();
  }

  deleteSupplier(id: any): void {
    // this.agentService.deleteAgent(id).subscribe(() => {
    //   this.ngOnInit();
    // });
  }

  editNavigate(currency?: any): void {
    if (currency) {
      this.modalType = 'edit';
      this.selectedCurrency = currency;
      this.currencyCode = this.selectedCurrency.currencyCode;
      this.currencyName = this.selectedCurrency.currencyName;
      this.lkrRate = this.selectedCurrency.lkrRate;
    } else {
      this.modalType = 'add';
    }
    this.isVisibleCurrencyAddEdit = true;
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }

  handleCancelAddEditCurrency(): void {
    this.currencyCode = '';
    this.currencyName = '';
    this.lkrRate = 0;
    this.selectedCurrency = null;
    this.isVisibleCurrencyAddEdit = false;
  }

  submitCurrencyData(): void {
    this.isLoading = true;
    if (this.selectedCurrency) {
      this.currencyService
        .updateCurrency({
          _id: this.selectedCurrency?._id,
          currencyCode: this.currencyCode,
          currencyName: this.currencyName,
          lkrRate: this.lkrRate,
          isBaseCurrency: this.currencyCode === 'LKR',
        })
        .subscribe(
          (res) => {
            this.isLoading = false;
            this.messages.create('success', 'Currency has been updated!');
            this.getPagedCurrencies();
            this.handleCancelAddEditCurrency();
          },
          (e: any) => {
            this.messages.create('error', 'Data should be unique!');
            this.isLoading = false;
          },
        );
    } else {
      this.currencyService
        .createCurrency({
          currencyCode: this.currencyCode,
          currencyName: this.currencyName,
          lkrRate: this.lkrRate,
          isBaseCurrency: this.currencyCode === 'LKR',
        })
        .subscribe(
          (res) => {
            this.isLoading = false;
            this.messages.create('success', 'New Currency has been added!');
            this.getPagedCurrencies();
            this.handleCancelAddEditCurrency();
          },
          (e: any) => {
            this.messages.create('error', 'Data should be unique!');
            this.isLoading = false;
          },
        );
    }
  }

  changeStatus(id: string, data: any): void {
    this.currencyService
      .updateCurrency({
        _id: id,
        active: !data?.active,
      })
      .subscribe((res) => {
        this.messages.create(
          'success',
          `Currency status changed to ${data?.active ? 'Inactive' : 'Active'}!`,
        );
        this.getPagedCurrencies();
      });
  }

  check(permission: any): boolean {
    return !_.includes(
      localStorage.getItem(SETTINGS.USER_PERMISSIONS),
      permission,
    );
  }
}
